import React,{ useState,useEffect } from 'react';
import MenuSelectProductType from './MenuSelectProduct';
import MenuProductView from './MenuProductView';
import MenuPositions from './MenuPosition';
import AnimationBtn from './AnimationBtn';
import MenuFeatures from './MenuFeatures';
import MenuColors from './MenuColors';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);

var isipad = (/CriOS/i.test(navigator.userAgent) && /ipad/i.test(navigator.userAgent)) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

export const userContext = React.createContext();
var prevCounter = 0;
var nextClicked = false;
var prevClicked = false;
var buttonSeq = ['onResetMode','TentModeClick','TheaterModeClick','TabletModeClick','onFrontClick','onTopClick','onRightClick','onLeftClick','openCloseClick','backliteClick','playPausevideoClick'];
var buttonSeq180 = ['onResetMode','color1Click','color2Click','onFrontClick','onTopClick','onRightClick','onLeftClick','onKeyFunction','onKeyMedia','onKeyTouch','backliteClick','openCloseClick','playPausevideoClick'];
var selectedButton = 'onResetMode';

var position = {
   'currentPos': 'reset',
   'close': 0,
   'nintyDegree': 1.04167,
   'reset': 2.08333,
   'top': 1.41,
   'tent': 3.125,
   'theatre': 4.1667,
   'tablet': 5.208,
}

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);
   const [displayed,setDisplayed] = useState(false);
   const [hidden,setHidden] = useState(true);
   const [laptop360FrontImg,setLaptop360FrontImg] = useState("./img/front180Black.png");
   const [laptop360TopImg,setLaptop360TopImg] = useState("./img/top360.png");
   const [laptop360LeftImg,setLaptop360LefttImg] = useState("./img/360_left.png");
   const [laptop360RightImg,setLaptop360RightImg] = useState("./img/360_right.png");
   const [counter,setCounter] = useState(0);
   const [playPause,setPlaypause] = useState("./img/play_btn.svg");
   const [playPauseVideo,setPlayPauseVideo] = useState(false);
   const [radioValue,setRadioValue] = useState('keyMediaMode');

   const handleAccordionChange = (panel) => (event,isExpanded) => {
      //console.log({ event,isExpanded });
      //setExpandedPanel(isExpanded ? panel  : false );
      if (isExpanded) {
         setExpandedPanel(panel);
         //console.log("shubham");
      } else {
         //  console.log("Pawar");
         setExpandedPanel(false)
      };
      // resetBacklitCloseImg();

   };

   const [camData,setCamData] = useState("");
   var animationSwitch = window.localStorage.getItem('Animation');
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            // console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }

   useEffect(() => {
      getData();
      animationSwitch = window.localStorage.getItem('Animation');
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      //window.localStorage.setItem('tent', false);
      //window.localStorage.setItem('tablet', false);
      //window.localStorage.setItem('theater', false);
      //window.localStorage.setItem('close', false);
      window.localStorage.setItem("position","reset");
      document.querySelector('#playPauseVBtn').classList.add('Mui-disabled');
      document.querySelector('#playPauseVBtn').style.pointerEvents = 'none';
      document.getElementById('whiteBtn').classList.add('select');
      // alert('moblandscap '+moblandscap )
   },[]);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   },[])
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

      let mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   })


   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }
   // console.log('animTime', animTime)

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here

      var opt = undefined,gp = camData[gotoposname];

      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt) opt = {};
         opt.zang = gp.pos[5];
      }
      // console.log('animationSwitch', animationSwitch)
      if (animationSwitch == 'off') {
         gp.time = 1
         // console.log('animationSwitch iffff', gp.time)
      }
      else {
         gp.time = animTime;
         // console.log('animationSwitch elseeee', gp.time)
      }
      console.log('animationSwitch',animationSwitch);
      console.log('gp.time',gp.time);
      window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4],gp.time,onComplete,slowInOut,opt);
      // console.log(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
   }
   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }

   let leftSideMenu = ["rLeft","rRight","zoomOut","sliderRange","zoomIn","previousView","resetView","nextView"];

   const hotspotIndex = () => {
      window.scene.groupApplyState("Media_Mode");
      if (document.querySelector('.MuiFormControlLabel-root.active')) {
         document.querySelector('.MuiFormControlLabel-root.active').classList.remove('active');
      }
      if (document.querySelector('.MuiAccordionDetails-root.active')) {
         document.querySelector('.MuiAccordionDetails-root.active').classList.remove('active');
      }
      /*  if (document.getElementById('mediaMode').classList.contains('active') != 'active') {
          document.getElementById('mediaMode').classList.add('active');
       } */
      if (window.localStorage.getItem('color') === 'laptopSilver') {
         window.scene.groupApplyState("Screenfill_1");
      }
      else if (window.localStorage.getItem('color') === 'laptopBlack') {
         window.scene.groupApplyState("Screenfill_2");
      }
      window.localStorage.removeItem('hotspot');
      setRadioValue('keyMediaMode');
      if (document.getElementById("hotspot1demo")) {
         document.getElementById("hotspot1demo").setAttribute("tabindex",'-1');
      }
      for (let i = 1; i <= 13; i++) {
         if (document.getElementById('hotspot' + i)) {
            document.getElementById('hotspot' + i).style.display = 'none';
            document.getElementById('hotspot' + i).setAttribute("tabindex","-1");
         }
      }
   }

   const reversAll = () => {
      hotspotIndex();
      /*  setPlayPauseVideo(false)
       setPlaypause("./img/play_btn.svg");
       window.playVideo = false;
       var tex = window.scene._Texture_ref["./img/screenfill_new.jpg"];
       var texture = window.scene._Textures[tex.tex_id];
       //  console.log(texture)
       if (texture != null) {
          var gl = window.scene.gl;
          gl.bindTexture(gl.TEXTURE_2D,texture);
          gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
          gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
             gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
       }
       if (document.getElementById('orion-keyboard-color-menu-wrapper')) {
          document.getElementById('orion-keyboard-color-menu-wrapper').style.display = 'none'
       } */
      // picker.setColor("#00f7ff"); //set initial color
      // picker.linkTo(onColorChange); //link to callback
      window.localStorage.removeItem('hotspot');
      window.scene.groupApplyState('stand_on');
      
      window.scene.clearRefine();
   }

   const [animStoped,setanimStoped] = useState(true);

   const animComplete = () => {
      setanimStoped(true);
      var g_navEnabled = true;
      // document.getElementById("onReset").style.pointerEvents = "all";
   }

   const resetBacklitCloseImg = () => {
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");

      // window.scene.materialReplace('LED_Backlit_ON_env', 'LED_Backlit_OFF_env');
      window.scene.clearRefine();

   }
   const resetTimeline1 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_01_A')) window.scene.getAnim("Screen_grp_timeline_01_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_01_A')) window.scene.getAnim("Hinge_grp_timeline_01_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_01_A')) window.scene.getAnim("Main_grp_timeline_01_A").stop();

      if (revers90Degree) {
         // window.scene.animPlayInTime("Screen_90_degree", 0, 0);
         // window.scene.animPlayInTime("Screen_90_to_close180", 0, 0);
         // window.scene.animPlayInTime("Screen_90_to_close360", 0, 0);
      }
      window.scene.animPlayInTime("Screen_grp_timeline_01_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_01_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_01_A",0,0);
      
      window.scene.clearRefine();
   }
   const resetTimeline2 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_02_A')) window.scene.getAnim("Screen_grp_timeline_02_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_02_A')) window.scene.getAnim("Hinge_grp_timeline_02_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_02_A')) window.scene.getAnim("Main_grp_timeline_02_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_02_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline3 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_03_A')) window.scene.getAnim("Screen_grp_timeline_03_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_03_A')) window.scene.getAnim("Hinge_grp_timeline_03_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_03_A')) window.scene.getAnim("Main_grp_timeline_03_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Screen_grp_timeline_03_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_03_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_03_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline4 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_04_A')) window.scene.getAnim("Main_grp_timeline_04_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_04_A')) window.scene.getAnim("Hinge_grp_timeline_04_A").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_04_A')) window.scene.getAnim("Screen_grp_timeline_04_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Main_grp_timeline_04_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0,0);
      window.scene.animPlayInTime("Screen_grp_timeline_04_A",0,0);
      window.scene.clearRefine();
   }
   const posClicked1 = () => {
      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('color');
      window.scene.animPlayInTime("Screen_grp_timeline_01",0,animTime);

   }

   //MenuSelectProduct
   const [laptop360,setlaptop360] = useState(true);

   const [laptop180,setlaptop180] = useState(false);

   const laptopClick = (event) => {

      setlaptop180(true);
      setlaptop360(false);
      console.log(laptop180);
      setCounter(0);
      selectedButton = 'onResetMode';
      setValue(event.target.value);
      setDisplayed(true);
      // setExpandedPanel(false);
      setHidden(false);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');

      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('laptop').setAttribute('aria-label','laptop radio butoon selected');
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");
      window.scene.groupApplyState("screenfill_180");

      setLaptop360FrontImg("./img/front180White.png");
      setLaptop360TopImg("./img/top180White.png");
      setLaptop360LefttImg("./img/180_white_left.png");
      setLaptop360RightImg("./img/180_white_right.png");
      resetBacklitCloseImg();

      window.localStorage.setItem("position","reset");
      window.localStorage.setItem("laptop","laptop180");
      window.localStorage.removeItem('color');

      var radiobtn1 = document.getElementById('twoinoneRadio');
      radiobtn1.checked = false;
      var radioSelector1 = document.querySelector('#twoinoneRadio')
      var nextSibling1 = radioSelector1.nextElementSibling;
      var selectSVG1 = nextSibling1.lastChild;
      selectSVG1.style.transform = 'scale(0)'
      // nextSibling1.classList.remove('PrivateRadioButtonIcon-checked-16')
      var radiobtn2 = document.getElementById('laptopRadio');
      radiobtn2.checked = true;
      var radioSelector2 = document.querySelector('#laptopRadio')
      var nextSibling2 = radioSelector2.nextElementSibling;
      var selectSVG2 = nextSibling2.lastChild;
      selectSVG2.style.transform = 'scale(1)'
      // nextSibling2.classList.add('PrivateRadioButtonIcon-checked-16')
      document.getElementById("laptopRadio").tabIndex = 1;

      window.localStorage.removeItem('hotspot');
      document.getElementById('whiteBtn').classList.add('select');
      document.getElementById('whiteBtn').classList.add('active');

      // var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      //  alreadySelected.classList.remove('active');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('whiteBtn').classList.add('active');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('select');
      }
      window.RT_RecordEvent("Product Type","Laptop",window.config.name);
      //add for tab issues
      document.getElementById("hotspot1").setAttribute("tabindex","-1");
      // document.getElementById("tentBtn").setAttribute("tabindex", "-1");
      // document.getElementById("theaterBtn").setAttribute("tabindex", "-1");
      // document.getElementById("tabletBtn").setAttribute("tabindex", "-1");

      document.getElementById("hotspot2").setAttribute("tabindex","-1");
      document.getElementById("hotspot3").setAttribute("tabindex","-1");
      document.getElementById("hotspot4").setAttribute("tabindex","-1");
      document.getElementById("hotspot5").setAttribute("tabindex","-1");
      document.getElementById("hotspot6").setAttribute("tabindex","-1");
      document.getElementById("hotspot7").setAttribute("tabindex","-1");
      document.getElementById("hotspot8").setAttribute("tabindex","-1");
      document.getElementById("hotspot9").setAttribute("tabindex","-1");
      document.getElementById("hotspot10").setAttribute("tabindex","-1");

      document.getElementById("hotspot11").setAttribute("tabindex","-1");
      document.getElementById("hotspot12").setAttribute("tabindex","-1");
      document.getElementById("hotspot13").setAttribute("tabindex","-1");

      document.getElementById("tentBtn").setAttribute("tabindex","-1");
      document.getElementById("theaterBtn").setAttribute("tabindex","-1");
      document.getElementById("tabletBtn").setAttribute("tabindex","-1");

      //  document.getElementById('laptop2in1').classList.remove('select');
      document.getElementById('laptop').classList.add('active');
      document.getElementById('laptop2in1').classList.remove('active');
      document.getElementById('laptop2in1').classList.remove('select');

      GotoPosInTimeNamedValue('Render_Cam_F50_FL',function () {

         window.scene.groupApplyState("Silver_180");
         window.scene.groupApplyState("screenfill_180");
      });

      // document.querySelector('#blackBtn').classList.add('Btnsubmenus');
      document.querySelector('#blackBtn').classList.remove('Mui-disabled');
      // document.querySelector('#blackBtn').style.pointerEvents = 'auto';
      document.querySelector('#blackBtn').style.pointerEvents = "auto";
      // document.querySelector('#blackBtn').setAttribute = ("onclick");
      // document.querySelector('#menucolor').setAttribute = ("onBlackBtnClick");


      document.querySelector('#tentBtn').classList.add('Mui-disabled');
      document.querySelector('#tentBtn').style.pointerEvents = 'none';
      // document.querySelector('#tentBtn').setAttribute("tabindex", "-1");

      document.querySelector('#theaterBtn').classList.add('Mui-disabled');
      document.querySelector('#theaterBtn').style.pointerEvents = 'none';
      // document.querySelector('#theaterBtn').setAttribute("tabindex", "-1");

      document.querySelector('#tabletBtn').classList.add('Mui-disabled');
      document.querySelector('#tabletBtn').style.pointerEvents = 'none';
      // document.querySelector('#tabletBtn').setAttribute("tabindex", "-1");
      document.getElementById("blackBtn").setAttribute("tabindex","1");

      // document.getElementById("tentBtn1").setAttribute("tabindex", "-1");
      // document.getElementById("theaterBtn1").setAttribute("tabindex", "-1");
      // document.getElementById("tabletBtn1").setAttribute("tabindex", "-1");

      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      } else {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      }


   }

   const [value,setValue] = useState('2 in 1');

   const select2in1Click = (event) => {
      setlaptop360(true);
      setlaptop180(false);
      console.log(laptop360);
      selectedButton = 'onResetMode';
      setValue(event.target.value);
      setDisplayed(false);
      setHidden(true);
      // setExpandedPanel(false);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('laptop2in1').setAttribute('aria-label','2in1 radio butoon selected');
      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }

      // var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      // if(alreadySelected != null){
      //   alreadySelected.classList.remove('active');
      // }
      document.getElementById('laptop2in1').classList.add('active');
      document.getElementById('laptop2in1').classList.add('select');
      document.getElementById('whiteBtn').classList.add('select');
      document.getElementById('whiteBtn').classList.add('active');
      document.getElementById('laptop').classList.remove('active');
      document.getElementById('laptop').classList.remove('select');
      document.getElementById("tentBtn").setAttribute("tabindex","1");
      document.getElementById("theaterBtn").setAttribute("tabindex","1");
      document.getElementById("tabletBtn").setAttribute("tabindex","1");

      // document.getElementById("blackBtn").setAttribute("tabindex", "-1");

      window.localStorage.removeItem('hotspot');
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screenfill_360");
      window.scene.groupApplyState("dynamic_reset");

      window.localStorage.setItem("laptop","laptop360");
      window.localStorage.removeItem('hotspot');

      var radiobtn1 = document.getElementById('laptopRadio');
      radiobtn1.checked = false;
      var radioSelector1 = document.querySelector('#laptopRadio')
      var nextSibling1 = radioSelector1.nextElementSibling;
      var selectSVG1 = nextSibling1.lastChild;
      selectSVG1.style.transform = 'scale(0)'
      var radiobtn2 = document.getElementById('twoinoneRadio');
      radiobtn2.checked = true;
      var radioSelector2 = document.querySelector('#twoinoneRadio')
      var nextSibling2 = radioSelector2.nextElementSibling;
      var selectSVG2 = nextSibling2.lastChild;
      selectSVG2.style.transform = 'scale(1)'

      window.localStorage.removeItem('color');
      document.getElementById("twoinoneRadio").tabIndex = 1;


      window.RT_RecordEvent("Product Type","2 in 1",window.config.name);
      //add for tab issues
      document.getElementById("hotspot1").setAttribute("tabindex","-1");
      document.getElementById("hotspot2").setAttribute("tabindex","-1");
      document.getElementById("hotspot3").setAttribute("tabindex","-1");
      document.getElementById("hotspot4").setAttribute("tabindex","-1");
      document.getElementById("hotspot5").setAttribute("tabindex","-1");
      document.getElementById("hotspot6").setAttribute("tabindex","-1");
      document.getElementById("hotspot7").setAttribute("tabindex","-1");
      document.getElementById("hotspot8").setAttribute("tabindex","-1");
      document.getElementById("hotspot9").setAttribute("tabindex","-1");
      document.getElementById("hotspot10").setAttribute("tabindex","-1");

      document.getElementById("hotspot11").setAttribute("tabindex","-1");
      document.getElementById("hotspot12").setAttribute("tabindex","-1");
      document.getElementById("hotspot13").setAttribute("tabindex","-1");


      setLaptop360FrontImg("./img/front180Black.png");
      setLaptop360TopImg("./img/top360.png");
      setLaptop360LefttImg("./img/360_left.png");
      setLaptop360RightImg("./img/360_right.png");

      resetBacklitCloseImg();

      GotoPosInTimeNamedValue('Render_Cam_F50_FL',function () {
         window.scene.groupApplyState("Silver");

      });
      document.querySelector('#blackBtn').classList.add('Mui-disabled');
      document.querySelector('#blackBtn').style.pointerEvents = "auto";
      // document.querySelector('#blackBtns').classList.remove('Btnsubmenus');

      // document.querySelector('#blackBtn').removeAttribute = ("onclick");

      // document.querySelector('#menucolor').removeAttribute = ("onBlackBtnClick");


      document.querySelector('#tentBtn').classList.remove('Mui-disabled');
      document.querySelector('#tentBtn').style.pointerEvents = 'auto';
      // document.querySelector('#tentBtn').setAttribute("tabindex", "1");

      document.querySelector('#theaterBtn').classList.remove('Mui-disabled');
      document.querySelector('#theaterBtn').style.pointerEvents = 'auto';
      // document.querySelector('#theaterBtn').setAttribute("tabindex", "1");

      document.querySelector('#tabletBtn').classList.remove('Mui-disabled');
      document.querySelector('#tabletBtn').style.pointerEvents = 'auto';
      // document.querySelector('#tabletBtn').setAttribute("tabindex", "1");
      document.getElementById("blackBtn").setAttribute("tabindex","1");

      // document.getElementById("tentBtn1").setAttribute("tabindex", "1");
      // document.getElementById("theaterBtn1").setAttribute("tabindex", "1");
      // document.getElementById("tabletBtn1").setAttribute("tabindex", "1");

      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      } else {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      }

   }

   //MenuProductView

   const onFrontClick = (isNextPrevious) => {
      hotspotIndex();
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); },1000);
      }
      console.log(position.nintyDegree,position.currentPos)

      //   var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      //    alreadySelected.classList.remove('active');
      // document.getElementById('frontBtn').classList.add('active');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('frontBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      var currentPosName = position.currentPos;


      selectedButton = 'onFrontClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Front view');
         document.getElementById('nextView').setAttribute('aria-label','Front view');
      }
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }

      window.localStorage.removeItem('hotspot');

      resetBacklitCloseImg();

      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("dynamic_reset");

      GotoPosInTimeNamedValue('Render_Cam_F25_JD',function () {
         window.localStorage.setItem('hotspot','front')

         if (isNextPrevious != true) {
            // alert("isNextPrevious");
            window.document.getElementById("hotspot1demo").focus();
         }
      })
      if (!(window.isipad || window.mob)) {
         /* if (document.getElementById("hotspot1demo")) {
            document.getElementById("hotspot1demo").setAttribute("tabindex",1);
         } */
         if (document.getElementById("hotspot1")) {
            document.getElementById("hotspot1").setAttribute("tabindex",1);
         }
         if (document.getElementById("hotspot2")) {
            document.getElementById("hotspot2").setAttribute("tabindex",1);
         }

         for (let i = 0; i < leftSideMenu.length; i++) {
            if (document.getElementById(leftSideMenu[i])) {
               document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
            }
         }
      }
      if (position.nintyDegree == position[currentPosName]) { position.currentPos = 'nintyDegree'; return; }
      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         console.log("Theater")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      }
      else {
         console.log("else")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      }

      window.RT_RecordEvent("Product Type","Front",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'nintyDegree';

   }

   const onRightClick = (isNextPrevious) => {
      hotspotIndex()
      //Update ZoomBar
      console.log(position.nintyDegree,position.currentPos)


      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      selectedButton = 'onRightClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','right view');

         document.getElementById('nextView').setAttribute('aria-label','right view');
      }
      window.localStorage.removeItem('hotspot');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('rightBtn').classList.add('active');


      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");
      window.localStorage.removeItem('hotspot');
      var slider = document.getElementById("sliderRange");

      resetBacklitCloseImg();

      window.scene.groupApplyState("Backlit_OFF");

      GotoPosInTimeNamedValue('Render_Cam_F26_R',function () {
         window.localStorage.setItem('hotspot','right')
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }


      });
      // window.document.getElementById("hotspot11").focus();
      if (!(window.isipad || window.mob)) {
         if (document.getElementById("hotspot6")) {
            document.getElementById("hotspot6").setAttribute("tabindex",1);
         }

         for (let i = 0; i < leftSideMenu.length; i++) {
            if (document.getElementById(leftSideMenu[i])) {
               document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
            }
         }
      }
      var currentPosName = position.currentPos;
      if (position.nintyDegree == position[currentPosName]) { position.currentPos = 'nintyDegree'; return; }
      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         console.log("Theater")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      }
      else {
         console.log("else")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      }
      window.scene.clearRefine();
      position.currentPos = 'nintyDegree';

      window.RT_RecordEvent("Product Type","Right",window.config.name);
      window.scene.clearRefine();
   }

   const onLeftClick = (isNextPrevious) => {
      hotspotIndex()
      //Update ZoomBar
      console.log(position.nintyDegree,position.currentPos)

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      console.log("left")
      selectedButton = 'onLeftClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','left view');

         document.getElementById('nextView').setAttribute('aria-label','left view');
      }
      window.localStorage.removeItem('hotspot');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }


      document.getElementById('leftBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      (window.localStorage.getItem("hotspot","right"))
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");

      window.scene.groupApplyState("Backlit_OFF");

      GotoPosInTimeNamedValue('Render_Cam_F26_L',function () {
         window.localStorage.setItem('hotspot','left')
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }


      });
      if (!(window.isipad || window.mob)) {
         if (document.getElementById("hotspot7")) {
            document.getElementById("hotspot7").setAttribute("tabindex",1);
         }

         for (let i = 0; i < leftSideMenu.length; i++) {
            if (document.getElementById(leftSideMenu[i])) {
               document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
            }
         }
      }
      var currentPosName = position.currentPos;
      if (position.nintyDegree == position[currentPosName]) { position.currentPos = 'nintyDegree'; return; }
      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         console.log("Theater")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      }
      else {
         console.log("else")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      }
      position.currentPos = 'nintyDegree';

      window.RT_RecordEvent("Product Type","Left",window.config.name);
      window.scene.clearRefine();
   }
   const onTopClick = (isNextPrevious) => {
      //Update ZoomBar
      hotspotIndex();
      console.log(position.top,position.currentPos)

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      selectedButton = 'onTopClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Top view');

         document.getElementById('nextView').setAttribute('aria-label','Top view');
      }
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }

      window.localStorage.removeItem('hotspot');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }


      document.getElementById('topBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");

      resetBacklitCloseImg();

      window.scene.groupApplyState("Backlit_OFF");

      GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () {

         window.localStorage.setItem('hotspot','top');
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }

      });
      if (!(window.isipad || window.mob)) {
         if (document.getElementById("hotspot3")) {
            document.getElementById("hotspot3").setAttribute("tabindex",1);
         }
         if (document.getElementById("hotspot4")) {
            document.getElementById("hotspot4").setAttribute("tabindex",1);
         }
         if (document.getElementById("hotspot5")) {
            document.getElementById("hotspot5").setAttribute("tabindex",1);
         }

         for (let i = 0; i < leftSideMenu.length; i++) {
            if (document.getElementById(leftSideMenu[i])) {
               document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
            }
         }
      }
      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      // if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
      //    console.log("Theater")
      //    window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      //    window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      // }
      // else {
      console.log("else")
      console.log('************************');
      window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      // }

      position.currentPos = 'top';

      window.RT_RecordEvent("Product Type","Top",window.config.name);
      window.scene.clearRefine();
   }

   //MenuFeatureView

   const [openCloseOnOff,setOpenCloseOnOff] = useState(false);
   const [backlit,setBacklite] = useState("./img/Backlite_Off.svg");
   const [opneClose,setOpenClose] = useState("./img/Lid_open.svg");
   const [backliteOnOff,setBackliteOnOff] = useState(false);

   const onKeyTouch = () => {
      //Update ZoomBar
      hotspotIndex();
      console.log(position.top,position.currentPos,' onKeyTouch');

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); },1000);
      }

      selectedButton = 'onKeyTouch';

      setRadioValue('keyTouchMode');

      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','OFF');
         document.getElementById('nextView').setAttribute('aria-label','OFF');
      }

      window.localStorage.removeItem('hotspot');

      var alreadySelected = document.querySelector('.MuiFormControlLabel-root.active');
      if (alreadySelected) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('touchFun').classList.add('active');

      resetBacklitCloseImg();

      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");

      laptop180 ? window.scene.groupApplyState("screenfill_180") : window.scene.groupApplyState("screenfill_360");

      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");

      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("Touch_Function_OFF");
      window.scene.groupApplyState("Screenfill_OFF");

      GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { });

      if (!(window.isipad || window.mob)) {
         for (let i = 0; i < leftSideMenu.length; i++) {
            if (document.getElementById(leftSideMenu[i])) {
               document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
            }
         }
      }
      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      // if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
      //    console.log("Theater")
      //    window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      //    window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      // }
      // else {
      window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      // }

      position.currentPos = 'top';

      window.RT_RecordEvent("Features","Touch Function Row",window.config.name);
      window.scene.clearRefine();
   }

   const onKeyFunction = () => {
      //Update ZoomBar
      hotspotIndex();
      
      console.log(position.top,position.currentPos,' onKeyFunction');

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); },1000);
      }

      selectedButton = 'onKeyFunction';

      setRadioValue('keyFunctionMode');

      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Function Mode');
         document.getElementById('nextView').setAttribute('aria-label','Function Mode');
      }

      window.localStorage.removeItem('hotspot');

      var alreadySelected = document.querySelector('.MuiFormControlLabel-root.active');
      if (alreadySelected) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('functionMode').classList.add('active');

      resetBacklitCloseImg();

      /*  if (window.localStorage.getItem('color') === 'laptopSilver') {
          window.scene.groupApplyState("Screenfill_1");
       }
       else if (window.localStorage.getItem('color') === 'laptopBlack') {
          window.scene.groupApplyState("Screenfill_2");
       } */

      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");

      laptop180 ? window.scene.groupApplyState("screenfill_180") : window.scene.groupApplyState("screenfill_360");

      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");

      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("Function_Mode");
   
      GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { });

      if (!(window.isipad || window.mob)) {
         for (let i = 0; i < leftSideMenu.length; i++) {
            if (document.getElementById(leftSideMenu[i])) {
               document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
            }
         }
      }

      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      // if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
      //    console.log("Theater")
      //    window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      //    window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      // }
      // else {
      window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      // }

      position.currentPos = 'top';

      window.RT_RecordEvent("Features","Function Mode",window.config.name);
      window.scene.clearRefine();
   }

   const onKeyMedia = () => {
      //Update ZoomBar
      hotspotIndex();
      console.log(position.top,position.currentPos,' onKeyMedia');

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); },1000);
      }

      selectedButton = 'onKeyMedia';

      setRadioValue('keyMediaMode');

      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Media Mode');
         document.getElementById('nextView').setAttribute('aria-label','Media Mode');
      }

      window.localStorage.removeItem('hotspot');

      var alreadySelected = document.querySelector('.MuiFormControlLabel-root.active');
      if (alreadySelected) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('mediaMode').classList.add('active');

      resetBacklitCloseImg();



      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");

      laptop180 ? window.scene.groupApplyState("screenfill_180") : window.scene.groupApplyState("screenfill_360");

      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");
      

      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("Media_Mode");


      GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { });

      if (!(window.isipad || window.mob)) {
         for (let i = 0; i < leftSideMenu.length; i++) {
            if (document.getElementById(leftSideMenu[i])) {
               document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
            }
         }
      }
      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      // if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
      //    console.log("Theater")
      //    window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      //    window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      // }
      // else {
      window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      // }

      position.currentPos = 'top';

      window.RT_RecordEvent("Features","Media Mode",window.config.name);
      window.scene.clearRefine();
   }

   const openCloseClick = () => {
      console.log(position.close,position.currentPos)
      //Update ZoomBar
      hotspotIndex();
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor() },1000);
      }

      selectedButton = 'openCloseClick';


      var fromPos = window.localStorage.getItem('hotspot')
      window.localStorage.removeItem('hotspot');
      window.localStorage.setItem('closeMode','on');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('openCloseBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }
      window.scene.groupApplyState("GP_open");
      setBackliteOnOff(false);
      window.scene.groupApplyState("Backlit_OFF");

      console.log(backliteOnOff);
      setBacklite("./img/Backlite_Off.svg");


      if (openCloseOnOff) {

         document.getElementById('openCloseBtn').setAttribute('aria-label','');
         document.getElementById('openCloseLid').innerHTML = 'Open Lid';
         if (!(mob || isipad)) {
            document.getElementById('previousView').setAttribute('aria-label','Open Lid');

            document.getElementById('nextView').setAttribute('aria-label','Open Lid');


         }
         setOpenCloseOnOff(false);
         console.log("open");
         setOpenClose("./img/Lid_open.svg");


         window.scene.groupApplyState("dynamic_reset");
         GotoPosInTimeNamedValue('Render_Cam_F50_FL',function () { });

         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);

         window.RT_RecordEvent("Features","Open Lid",window.config.name);
         window.scene.clearRefine();
         position.currentPos = 'reset';
      } else {

         document.getElementById('openCloseBtn').setAttribute('aria-label','');
         document.getElementById('openCloseLid').innerHTML = 'Close Lid';
         if (!(mob || isipad)) {
            document.getElementById('previousView').setAttribute('aria-label','Close Lid');

            document.getElementById('nextView').setAttribute('aria-label','Close Lid');
         }
         setOpenCloseOnOff(true);
         console.log("close");
         setBackliteOnOff(false);
         setOpenClose("./img/Lid_close.svg");


         window.scene.groupApplyState("dynamic_reset");
         GotoPosInTimeNamedValue('Render_Cam_F0_Close',function () { });

         var currentPosName = position.currentPos;
         if (position.close == position[currentPosName]) { position.currentPos = 'close'; return; }
         if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
            console.log("Theater")
            window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.close,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
            window.scene.animPlayAllChildrenInTime("SCREEN",position.close,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         }
         else {
            console.log("else")
            window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.close,animTime,undefined,undefined,undefined,true,position[currentPosName],0);

            window.scene.animPlayAllChildrenInTime("SCREEN",position.close,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         }

         window.RT_RecordEvent("Features","Close Lid",window.config.name);
         window.scene.clearRefine();
         position.currentPos = 'close';
      }

      for (let i = 0; i < leftSideMenu.length; i++) {
         if (document.getElementById(leftSideMenu[i])) {
            document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
         }
      }

   }

   let backliteVar = document.getElementById('backlitBtn');

   const backliteClick = () => {
      hotspotIndex();
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      selectedButton = 'backliteClick';


      window.localStorage.removeItem('hotspot');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('backlitBtn').classList.add('active');

      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("dynamic_reset");


      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");

      resetBacklitCloseImg();

      GotoPosInTimeNamedValue('Render_Cam_F28_Rear',function () {

         window.localStorage.setItem('hotspot','backlit');

         window.scene.clearRefine();
      })

      //add for tab issues
      for (let i = 0; i < leftSideMenu.length; i++) {
         if (document.getElementById(leftSideMenu[i])) {
            document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
         }
      }

      if (backliteOnOff) {

         console.log("off");
         setBackliteOnOff(false);
         // backliteVar.setAttribute.ariaLabel = "Close dialog";
         document.getElementById('backlitBtn').setAttribute('aria-label','');
         document.getElementById('backlitOnnOff').innerHTML = 'Backlit off';
         if (!(mob || isipad)) {
            document.getElementById('previousView').setAttribute('aria-label','Backlit off');
            document.getElementById('nextView').setAttribute('aria-label','Backlit off');
         }
         GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { })

         window.scene.groupApplyState("Backlit_OFF");
         // window.scene.clearRefine();
         // document.getElementById('backlitOff').style.display="none";
         // document.getElementById('backlitOn').style.display="block";
         // window.document.getElementById('backlitOff').src="./img/Backlite_Off.svg";
         window.RT_RecordEvent("Features","Backlite Off",window.config.name);

      } else {
         // backliteVar.setAttribute.ariaLabel = "Backlit on";
         document.getElementById('backlitBtn').setAttribute('aria-label','');
         document.getElementById('backlitOnnOff').innerHTML = 'Backlit on';
         if (!(mob || isipad)) {
            document.getElementById('previousView').setAttribute('aria-label','Backlit on');
            document.getElementById('nextView').setAttribute('aria-label','Backlit on');
         }
         setBackliteOnOff(true);
         console.log("on");
         setBacklite("./img/Backlite_On.svg");
         GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () {
         })
         window.scene.groupApplyState("Backlit_ON");
         // document.getElementById('backlitOn').style.display="none";
         // document.getElementById('backlitOff').style.display="block";
         // window.document.getElementById('backlitOn').src="./img/Backlite_On.svg";
         window.RT_RecordEvent("Features","Backlite On",window.config.name);
         window.scene.clearRefine();

      }
      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         console.log("Theater")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      }
      else {
         console.log("else")
         window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);

         window.scene.animPlayAllChildrenInTime("SCREEN",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      }
      window.scene.clearRefine();
      position.currentPos = 'top';
   }

   //menucolor

   const color1Click = () => {
      console.log('color1Click');
      hotspotIndex();

      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('whiteBtn').classList.add('select');
      document.getElementById('whiteBtn').classList.add('active');

      window.localStorage.setItem("position","reset");
      selectedButton = 'color1Click';

      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      setLaptop360FrontImg("./img/front180Black.png");
      setLaptop360TopImg("./img/top360.png");
      setLaptop360LefttImg("./img/180_white_left.png");
      setLaptop360RightImg("./img/180_white_right.png");
      window.scene.groupApplyState("screenfill_180");
      window.localStorage.setItem("color","laptopSilver");
      setPort4Click(false);
      if (window.localStorage.getItem('laptop') == 'laptop360') {
         window.scene.groupApplyState("black");
      }
      else if (window.localStorage.getItem('laptop') == 'laptop180') {
         window.scene.groupApplyState("Silver_180");
         window.scene.groupApplyState("screenfill_180");
      }
      window.scene.groupApplyState("Screenfill_1");
      //console.log('openCloseOnOff' + openCloseOnOff);
      if (openCloseOnOff) {
         setTimeout(function () {
            setOpenCloseOnOff(true);
            setOpenClose("./img/Lid_close.svg");
         },300);
      }
      for (let i = 0; i < leftSideMenu.length; i++) {
         if (document.getElementById(leftSideMenu[i])) {
            document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
         }
      }
      window.localStorage.setItem("silver",true);
      window.RT_RecordEvent("Color","Aluminium",window.config.name);
      window.scene.clearRefine();
   }

   const color2Click = () => {
      console.log('color2Click');
      hotspotIndex();
      window.localStorage.setItem("position","reset");
      window.localStorage.setItem("color","laptopBlack");
      window.localStorage.removeItem('closeMode');

      //console.log('openCloseOnOff' + openCloseOnOff);
      if (openCloseOnOff) {
         setTimeout(function () {
            setOpenCloseOnOff(true);
            setOpenClose("./img/Lid_close.svg");
         },300);
      }

      selectedButton = 'color2Click';

      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      setLaptop360FrontImg("./img/front180White.png");
      setLaptop360TopImg("./img/top180White.png");
      setLaptop360LefttImg("./img/180_black_left.png");
      setLaptop360RightImg("./img/180_black_right.png");
      window.scene.groupApplyState("screenfill_180");
      setPort2Click(false);
      setPort1Click(false);
      setPort3Click(false);
      setPort4Click(false);

      window.localStorage.setItem("Carbon_Fibre",true);

      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('whiteBtn').classList.remove('select');
      document.getElementById('whiteBtn').classList.remove('active');
      document.getElementById('blackBtn').classList.add('select');
      document.getElementById('blackBtn').classList.add('active');

      window.scene.groupApplyState("white");
      window.scene.groupApplyState("Screenfill_2");

      window.RT_RecordEvent("Color","Carbon Fiber",window.config.name);
      for (let i = 0; i < leftSideMenu.length; i++) {
         if (document.getElementById(leftSideMenu[i])) {
            document.getElementById(leftSideMenu[i]).setAttribute("tabindex",1);
         }
      }
      window.scene.clearRefine();
   }

   const playPausevideoClick = (isNextPrevious) => {
      console.log('playPausevideoClick')
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      //
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      selectedButton = 'playPausevideoClick';
      reversAll();
      // reverAnimation();
      // hideGraphics();

      window.localStorage.removeItem('hotspot');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('playPauseVBtn').classList.add('active');

      window.localStorage.setItem("position","reset");

      if (playPauseVideo) {
         console.log("pause");
         setTimeout(() => {

            if (document.getElementById('playPauseVBtn')) {
               document.getElementById('playPauseVBtn').setAttribute('aria-label','');
            }
            document.getElementById('playPauseVideo').innerHTML = 'Play Video';
            if (!(mob || isipad)) {
               if (document.getElementById('previousView')) {
                  document.getElementById('previousView').setAttribute('aria-label','Play Video');
               }
               if (document.getElementById('nextView')) {
                  document.getElementById('nextView').setAttribute('aria-label','Play Video');
               }
            }
            setPlayPauseVideo(false)
            setPlaypause("./img/play_btn.svg");
            window.playVideo = false;
            var tex = window.scene._Texture_ref["screenfill_new.jpg"];
            var texture = window.scene._Textures[tex.tex_id];
            //  console.log(texture)
            if (texture != null) {
               var gl = window.scene.gl;
               gl.bindTexture(gl.TEXTURE_2D,texture);
               gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
               gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
                  gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
            }
            GotoPosInTimeNamedValue('Render_Cam_F16_FF',function () {
               window.scene.groupApplyState('stand_on');
               window.localStorage.removeItem('hotspot');
               animComplete();

            });
            window.scene.clearRefine();
         },500)

      } else {
         console.log("play");
         setTimeout(() => {

            if (document.getElementById('playPauseVBtn')) {
               document.getElementById('playPauseVBtn').setAttribute('aria-label','');
            }
            document.getElementById('playPauseVideo').innerHTML = 'Pause Video';
            if (!(mob || isipad)) {
               if (document.getElementById('previousView')) {
                  document.getElementById('previousView').setAttribute('aria-label','Pause Video');
               }
               if (document.getElementById('nextView')) {
                  document.getElementById('nextView').setAttribute('aria-label','Pause Video');
               }
            }
            setPlayPauseVideo(true)

            setPlaypause("./img/pause_btn.svg");
            window.playVideo = true;
            GotoPosInTimeNamedValue('Render_Cam_F16_FF',function () {
               window.scene.groupApplyState('stand_on');
               window.localStorage.removeItem('hotspot');
               animComplete();

            });
            window.scene.clearRefine();
         },500)

      }



      window.RT_RecordEvent("Features","playPausevideo",window.config.name);

      window.scene.clearRefine();
   }
   //Menu Position

   const [port1Click,setPort1Click] = useState(false);
   const [port2Click,setPort2Click] = useState(false);
   const [port3Click,setPort3Click] = useState(false);
   const [port4Click,setPort4Click] = useState(false);
   const [port5Click,setPort5Click] = useState(true);

   const [nextClick,setNextClick] = useState(false);
   const [prevClick,setPrevClick] = useState(false);

   const TentModeClick = () => {
      console.log(position.tent,position.currentPos)

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('tentBtn').classList.add('active');
      window.scene.groupApplyState("screen_360");

      selectedButton = 'TentModeClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Tent Mode');

         document.getElementById('nextView').setAttribute('aria-label','Tent Mode');
      }
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");
      window.localStorage.removeItem('hotspot');
      GotoPosInTimeNamedValue('Render_Cam_F25_JD',function () {
         window.scene.groupApplyState("GP_tent");
      });

      var currentPosName = position.currentPos;
      if (position.tent == position[currentPosName]) { position.currentPos = 'tent'; return; }
      window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.tent,animTime,undefined,undefined,undefined,true,position[currentPosName],4);
      window.scene.animPlayAllChildrenInTime("SCREEN",position.tent,animTime,undefined,undefined,undefined,true,position[currentPosName],4);

      window.RT_RecordEvent("Positions","Tent",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'tent';

   }

   const TheaterModeClick = () => {
      console.log(position.theatre,position.currentPos)

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('theaterBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");

      window.localStorage.removeItem('closeMode')
      selectedButton = 'TheaterModeClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Theater Mode');

         document.getElementById('nextView').setAttribute('aria-label','Theater Mode');
      }
      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("all_GP_off");
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");

      window.localStorage.removeItem('hotspot');
      GotoPosInTimeNamedValue('Render_Cam_F28_Rear');

      var currentPosName = position.currentPos;
      if (position.theatre == position[currentPosName]) { position.currentPos = 'theatre'; return; }
      window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.theatre,animTime,undefined,undefined,undefined,true,position[currentPosName],9);
      window.scene.animPlayAllChildrenInTime("SCREEN",position.theatre,animTime,undefined,undefined,undefined,true,position[currentPosName],4);

      window.RT_RecordEvent("Positions","Theatre",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'theatre';

   }
   const TabletModeClick = () => {
      console.log(position.tent,position.currentPos)

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }


      document.getElementById('tabletBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("all_GP_off");

      selectedButton = 'TabletModeClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Tablet Mode');

         document.getElementById('nextView').setAttribute('aria-label','Tablet Mode');
      }
      window.scene.groupApplyState("Backlit_OFF");
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.svg");

      window.localStorage.removeItem('hotspot');
      GotoPosInTimeNamedValue('Render_Cam_F0_Close');

      var currentPosName = position.currentPos;
      if (position.tablet == position[currentPosName]) { position.currentPos = 'tablet'; return; }
      window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320",position.tablet,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      window.scene.animPlayAllChildrenInTime("SCREEN",position.tablet,animTime,undefined,undefined,undefined,true,position[currentPosName],10);

      window.RT_RecordEvent("Positions","Tablet",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'tablet';
   }
   const resetMode = () => {
      selectedButton = 'onResetMode';
      GotoPosInTimeNamedValue('Render_Cam_F50_FL',function () { })
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Reset Mode');

         document.getElementById('nextView').setAttribute('aria-label','Reset Mode');
      }
   }
   const onResetMode = () => {
      //Update ZoomBar
      console.log(position.tent,position.currentPos)

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      // var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      //   alreadySelected.classList.remove('active');

      // document.getElementById('whiteBtn').classList.add('active');


      window.scene.groupApplyState("screen_180");
      // window.scene.groupApplyState("GP_open");
      // window.scene.groupApplyState("dynamic_reset");
     // window.localStorage.removeItem('color');
      // if (laptop180) {
      //    window.scene.groupApplyState("screenfill_180");
      // } else {
      //    window.scene.groupApplyState("screenfill_360");
      // }
      if (window.localStorage.getItem('color') === 'laptopSilver') {
         window.scene.groupApplyState("Screenfill_1");
      }
      else if (window.localStorage.getItem('color') === 'laptopBlack') {
         window.scene.groupApplyState("Screenfill_2");
      }
      // selectedButton = 'onResetMode';

      if (selectedButton == 'onFrontClick') {
         console.log("front onreset")
         GotoPosInTimeNamedValue('Render_Cam_F50_FL',function () {

         });
         onFrontClick();
      }
      else if (selectedButton == 'onTopClick') {
         console.log("top onreset")

         GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { });
         onTopClick();
      }
      else if (selectedButton == 'onRightClick') {
         onRightClick();
         GotoPosInTimeNamedValue('Render_Cam_F26_R',function () {
            window.localStorage.setItem('hotspot','right');
         })
      }
      else if (selectedButton == 'onLeftClick') {
         onLeftClick();
         GotoPosInTimeNamedValue('Render_Cam_F26_L',function () {
            window.localStorage.setItem('hotspot','left');
         })
      }
      else if (selectedButton == 'onKeyTouch') {
         GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { });
          onKeyTouch();
      }
      else if (selectedButton == 'onKeyFunction') {
         GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { });
         onKeyFunction();
      }
      else if (selectedButton == 'onKeyMedia') {
         GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { });
         onKeyMedia();
        
      }
      else if (selectedButton == 'openCloseClick') {
         if (openCloseOnOff) {
            // setOpenCloseOnOff(false);
            //   setOpenClose("./img/Lid_open.svg");
            //   window.scene.groupApplyState("dynamic_reset");

            GotoPosInTimeNamedValue('Render_Cam_F0_Close',function () {

            });


         } else {
            // setOpenCloseOnOff(true);
            //   setOpenClose("./img/Lid_close.svg");
            // window.scene.groupApplyState("dynamic_reset");
            GotoPosInTimeNamedValue('Render_Cam_F50_FL',function () {

            });
         }

      }
      else if (selectedButton == 'backliteClick') {
         //   if (backliteOnOff) {

         //     // console.log("off");
         //     // setBackliteOnOff(false);
         //     GotoPosInTimeNamedValue('Render_Cam_F198_Top', function(){})

         //     // window.scene.groupApplyState("Backlit_OFF");
         //     window.scene.clearRefine();
         //     // setBacklite("./img/Backlite_Off.svg");
         // } else {

         // setBackliteOnOff(true);
         // console.log("on");
         // setBacklite("./img/Backlite_On.svg");
         GotoPosInTimeNamedValue('Render_Cam_F34_Top',function () { })
         // window.scene.groupApplyState("Backlit_ON");
         window.scene.clearRefine();

      }
      else if (selectedButton == 'playPausevideoClick') {
         playPausevideoClick();
         if (playPauseVideo) {
            console.log("pause");
            setTimeout(() => {

               if (document.getElementById('playPauseVBtn')) {
                  document.getElementById('playPauseVBtn').setAttribute('aria-label','');
               }
               document.getElementById('playPauseVideo').innerHTML = 'Play Video';
               if (!(mob || isipad)) {
                  if (document.getElementById('previousView')) {
                     document.getElementById('previousView').setAttribute('aria-label','Play Video');
                  }
                  if (document.getElementById('nextView')) {
                     document.getElementById('nextView').setAttribute('aria-label','Play Video');
                  }
               }
               setPlayPauseVideo(false)
               setPlaypause("./img/play_btn.svg");
               window.playVideo = false;
               var tex = window.scene._Texture_ref["screenfill_new.jpg"];
               var texture = window.scene._Textures[tex.tex_id];
               //  console.log(texture)
               if (texture != null) {
                  var gl = window.scene.gl;
                  gl.bindTexture(gl.TEXTURE_2D,texture);
                  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
                  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
                     gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
               }
               GotoPosInTimeNamedValue('Render_Cam_F16_FF',function () {
                  window.scene.groupApplyState('stand_on');
                  window.localStorage.removeItem('hotspot');
                  animComplete();

               });
               window.scene.clearRefine();
            },500)

         } else {
            console.log("play");
            setTimeout(() => {

               if (document.getElementById('playPauseVBtn')) {
                  document.getElementById('playPauseVBtn').setAttribute('aria-label','');
               }
               document.getElementById('playPauseVideo').innerHTML = 'Pause Video';
               if (!(mob || isipad)) {
                  if (document.getElementById('previousView')) {
                     document.getElementById('previousView').setAttribute('aria-label','Pause Video');
                  }
                  if (document.getElementById('nextView')) {
                     document.getElementById('nextView').setAttribute('aria-label','Pause Video');
                  }
               }
               setPlayPauseVideo(true)

               setPlaypause("./img/pause_btn.svg");
               window.playVideo = true;
               GotoPosInTimeNamedValue('Render_Cam_F16_FF',function () {
                  window.scene.groupApplyState('stand_on');
                  window.localStorage.removeItem('hotspot');
                  animComplete();

               });
               window.scene.clearRefine();
            },500)

         }


      }
      else if (selectedButton == 'onResetMode') {
         resetMode()
         GotoPosInTimeNamedValue('Render_Cam_F50_FL',function () { })
      }

      // selectedButton = 'onResetMode';
      // setExpandedPanel(false);


      // resetBacklitCloseImg();
      // window.localStorage.removeItem('closeMode');
      // window.scene.groupApplyState("Backlit_OFF");
      // window.localStorage.removeItem('hotspot');
      // GotoPosInTimeNamedValue('Render_Cam_F50_FL');

      // GotoPosInTimeNamedValue('Render_Cam_F50_FL', function(){
      if (window.localStorage.getItem("Carbon_Fibre") == true) {
         window.scene.groupApplyState("Carbon_Fibre_180A");
         window.scene.groupApplyState("Screen_Fill_180_ON");
      }
      else if (window.localStorage.getItem("silver") == true) {
         window.scene.groupApplyState("Silver");
         window.scene.groupApplyState("Screen_Fill_180_Silver_ON");
      }

      window.scene.clearRefine();
      // });
      // var currentPosName = position.currentPos;

      //   if(position.reset == position[currentPosName]) {position.currentPos = 'reset';return;}

      //   if(position.currentPos == 'theatre' || position.currentPos == 'tablet'){
      //     console.log("Theater")
      //     window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320", position.reset, animTime, undefined, undefined, undefined, true,  position[currentPosName], 10);
      //     window.scene.animPlayAllChildrenInTime("SCREEN", position.reset, animTime, undefined, undefined, undefined, true,  position[currentPosName], 10);
      //   } else {

      //   window.scene.animPlayAllChildrenInTime("CA_XPS_Tributo_ADL_9320", position.reset, animTime, undefined, undefined, undefined, true,  position[currentPosName], 0);
      //   window.scene.animPlayAllChildrenInTime("SCREEN", position.reset, animTime, undefined, undefined, undefined, true,  position[currentPosName], 0);
      //   }
      //   window.scene.clearRefine();
      //   position.currentPos = 'reset';


   }

   const onPreviousMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      // alert(selectedButton)

      var prevButton;
      var selectedButtonIndex = buttonSeq180.findIndex(element => element === selectedButton)
      if (selectedButton == 'onFrontClick' || selectedButton == 'onResetMode' || selectedButton == 'color1Click' || selectedButton == 'color2Click') {
         prevButton = 'openCloseClick';
      } else {
         prevButton = buttonSeq180[selectedButtonIndex - 1];
      }

      if (prevButton == 'onFrontClick') onFrontClick(true);
      else if (prevButton == 'color1Click') color1Click(true);
      else if (prevButton == 'color2Click'){
         setExpandedPanel("panel4");

         color2Click(true);
      } 
      else if (prevButton == 'onTopClick') onTopClick(true);
      else if (prevButton == 'onRightClick') onRightClick(true);
      else if (prevButton == 'onLeftClick') {
         onLeftClick(true);
         setExpandedPanel("panel1");
      }
      else if (prevButton == 'onKeyFunction') { onKeyFunction(true) }
      else if (prevButton == 'onKeyMedia') { onKeyMedia(true) }
      else if (prevButton == 'onKeyTouch') { onKeyTouch(true) }
      else if (prevButton == 'backliteClick') backliteClick(true);
      else if (prevButton == 'openCloseClick') {
         openCloseClick(true);
         setExpandedPanel("panel3");
      }
   }

   const onNextMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var nextButton;
      var selectedButtonIndex = buttonSeq180.findIndex(element => element === selectedButton)
      if (selectedButton == 'openCloseClick' || selectedButton == 'onResetMode' || selectedButton == 'color1Click' || selectedButton == 'color2Click') {
         nextButton = 'onFrontClick';
      } else {
         nextButton = buttonSeq180[selectedButtonIndex + 1];
      }

      // else {
      //    var nextButton;
      //    var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
      //    if (selectedButton == 'backliteClick') {
      //       nextButton = 'onFrontClick';
      //    } else {
      //       nextButton = buttonSeq[selectedButtonIndex + 1];
      //    }
      // }
      // alert(laptop180)


      // if (nextButton == 'TentModeClick') {
      //    TentModeClick(true);
      //    setExpandedPanel("panel2");
      // }
      // else if (nextButton == 'TheaterModeClick') TheaterModeClick(true);
      // else if (nextButton == 'TabletModeClick') TabletModeClick(true);
      if (nextButton == 'color1Click') {
         color1Click(true);
         setExpandedPanel("panel4");

      }
      else if (nextButton == 'color2Click') {
         color2Click(true);
         // setExpandedPanel("panel1");
      }
      else if (nextButton == 'onFrontClick') {
         onFrontClick(true);
         setExpandedPanel("panel1");
      }
      else if (nextButton == 'onTopClick') { onTopClick(true) }
      else if (nextButton == 'onRightClick') { onRightClick(true) }
      else if (nextButton == 'onLeftClick') { onLeftClick(true) }
      else if (nextButton == 'onKeyFunction') {
         onKeyFunction(true);
         setExpandedPanel("panel3");
      }
      else if (nextButton == 'onKeyMedia') { onKeyMedia(true) }
      else if (nextButton == 'onKeyTouch') { onKeyTouch(true) }
      else if (nextButton == 'backliteClick') { backliteClick(true) }
      else if (nextButton == 'openCloseClick') { openCloseClick(true) }
   }

   const [animValue,setAnimValue] = useState("On");

   useEffect(() => {
      window.localStorage.setItem('Animation','on');
      document.getElementById("animSwitchValue").checked = 'true';

      setAnimValue("On");
      document.getElementsByClassName('onOff')[0].style.left = "-17px";

      window.localStorage.setItem("color","laptopSilver");

   },[]);


   const setAnimationSwitch = (e) => {
      console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');
         window.RT_RecordEvent("Animations","Off",window.config.name);

         // alert("Animation On");

      } else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue").checked = true;

         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         // alert("Animation Off");
         window.RT_RecordEvent("Animations","On",window.config.name);
      }
   }
   const displayName = (e) => {
      console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
         // alert("Animation On");

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');
         document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked Off');
         // alert("Animation Off");

      }

   }


   return (
      <>
         {/* <Hidden only={["xs",'sm']}> */}
         {!mob && <HowToUse />}
         {/* </Hidden> */}
         <Hidden only={['sm','md','lg','xl']}>

            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }} variant="outlined" color="primary" endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px',height: '23px' }} />} onClick={props.toggleDrawerAction}>Main Menu</Button>
            <Howtousenew />

         </Hidden >
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>
         {/* <MenuSelectProductType tabIndex="1" name="Select Product Type" onclicked={laptopClick} onclickedtwo={select2in1Click} value={value} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')}/> */}
         {/* <userContext.Provider value=""> */}
         <MenuColors id="menuColor" name="Colors" onWhiteBtnClick={color1Click} onBlackBtnClick={color2Click} expanded={expandedPanel === 'panel4'} onChanged={handleAccordionChange('panel4')} />
         {/* </userContext.Provider> */}
         {/* <MenuPositions name="Positions" tabIndex="1" onTentMode={TentModeClick} onTheaterMode={TheaterModeClick} onTabletMode={TabletModeClick} expanded={expandedPanel === 'panel2'} onChanged={handleAccordionChange('panel2')} /> */}
         <MenuProductView onFrontBtnClick={onFrontClick} onTopBtnClick={onTopClick} onLeftBtnClick={onLeftClick} onRightBtnClick={onRightClick} imgfront={laptop360FrontImg} imgtop={laptop360TopImg} imgleft={laptop360LeftImg} imgright={laptop360RightImg} name="Product View" expanded={expandedPanel === 'panel1'} onChanged={handleAccordionChange('panel1')} />

         <MenuFeatures name="Features" tobechange={opneClose} tobeChanged={backlit} tobechangevideo={playPause} openClosedClicked={openCloseClick} onOffBackliteClicked={backliteClick} playPauseVideo={playPause} onPlayPausevideoClicked={playPausevideoClick} expanded={expandedPanel === 'panel3'} onChanged={handleAccordionChange('panel3')} onRadioDefault={radioValue} keyTouch={onKeyTouch} keyFunction={onKeyFunction} keyMedia={onKeyMedia} />

         <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} />

      </>
   );
}

export default MainMenu;